var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.1186,
    height: 21.1186,
    fill: "url(#pattern0_2369_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2369_33",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2369_33",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2369_33",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD0ElEQVR4nO2du2sVQRSHJ2psBB+g+MB/QCwUfHRGUeMD1CKwYBEMyZ3fb0gkCDaWVxQESxWJD6KIVdIkSEC0iYKFjYqVltqISaEWahIFV8ZcUST3mhv2cXb2fHCqwO4552Mz7MydHWMURVEURVEURVECgWSrc66d5DkAt0gOZxUABgAczrsHIoiiaCmAUyQnScY5xyVjTIspKyRXA3gsQET8V9wopZTe3t5VAF4LEBDPEVdLJ4XkmIDGxyrFGOMHUAENj/XfVw0ADxs04SPJEQDX0wzqkzILyRUkv9Up/llfX9+6jPKIVYoxxjm3s17h1tptWeVBHVNmAXCsTsGfq9XqoqzyoA70s5CM6hQ7mXEesQ70xRBygeRUaaRIF+Kc20PyQGmkFEGImf17OaQURUhppBRJSCmkFE1I8FKKKCRoKUUVEqyUIgsJUkrRhQQnJQQhQUkJRUgwUkISEoQUQUJm5srDWntkAdc6NA8pMqfuBQl5UyePiwu8XjGlCBIyNlceAKYB7C+NFEFCbIOm/aj9gO/mAn488fI/QmRJkSKks7NzGcl382heKgHgvJGAFCEe59yJHIV8t9ZuNHkjSYiH5JW8pJA8avJGmhBjTAvJM37cyEFIZPJGoJBfkGwj+VSFCBHym0qlsonkaQCXSQ4ltCFoWoUIosFmJBWSBypEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGKUQAmA3yUcAJgB8yCgm/D2ttbuarDlsIdbarQ3mh+K0w9/bObeliZrDFkLyWl4y+EfKQBP5Bi9kOG8hJIeayDdsIdZaCBBim6g5bCF+PzuAOznKuN3MnvrghfyzmNRRu2YW0eHvuYCayyGkKKgQYagQYagQYagQYagQYagQYZRGiLV2c5LvIX73lP+WcAo1l+JN/W4ab+EAvgI4nnDNYQvJYC5rKsmPcQYvJKPZ3ijBmoMXkvp6iLV2b4I1hy3Er9alvGL4IoqixQnWHLaQ2nXaAIwnuaZO8q0/u6S7u3tNwjWHL6RIUIXIQoUIQ4UIQ4UIQ4UIQ4UIQ4UIQ4UIQ7QQKQe6ZIWvieSXuWr2vTCSjzwiud0EhmtQL4Adog8FA/Cc5HoTCD09PRv8RGUdITP9/f3LjQRIPmjwlHwCMJr2sXlIP0Z9LQ2ejvtGCtbagw2ElCKcc+1GEgDu5d0U5hcjRhpdXV0rBR9OHKcYr/w4agQf3z0uoElxFgHgSaVSWWskQ7KVZH9th2scaLwnedLXaoqCT9Z/wBjAWZKDSXzJjfnGYK2WfdVqdUne/VUURVEURVEURTEJ8RPn8QLkswyLzwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.0821300e5b6a0b3f71cbeadcf79e8a94.svg";
export { ForwardRef as ReactComponent };